import styled from 'styled-components';
import Headline from '@klv/atoms/headline';
import Typography from '@klv/atoms/typography';
import Grid from '@klv/utils/grid';
import type { ITransientProps } from '../types';

export const StatsDisclaimer = styled(Typography)`
  grid-column: 1 / -1;
    margin: 2.4rem 0 0;

  ${({ theme }) => theme.screenSize.s576.mediaQuery} {
    margin-top: 3.2rem;
  }
`;

export const StatsHeadline = styled(Headline)<ITransientProps>`
  color: ${({ theme, $background }) => theme.stats[$background].headline};
  grid-column: 1 / 9;
  padding-bottom: 1.4rem;
`;

export const StyledGrid = styled(Grid)`
  grid-row-gap: 2.8rem;

  ${({ theme }) => theme.screenSize.s576.mediaQuery} {
    grid-row-gap: 4.8rem;
  }
`;

export const StyledStats = styled.section<ITransientProps>`
  background-color: ${({ $background, theme }) => theme.stats[$background].background};
  ${({ theme }) => theme.globalPadding};
`;
